import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import { useAppMutation } from './useAppMutation';

interface UpdateCourseRecurrencePayload {
  id: string;
  recurrence: number;
}

export const useUpdateCourseRecurrence = () => {
  const queryClient = useQueryClient();

  return useAppMutation<unknown, unknown, UpdateCourseRecurrencePayload>(
    'put',
    '/Integration/Course/UpdateCourse',
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.trainingCourses.key });
      },
    }
  );
};
